window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.recentCoursesBox = window.locales.am.recentCoursesBox || {};window.locales.am.recentCoursesBox = {...window.locales.am.recentCoursesBox, ...{
    "heading": "የቅርብ ጊዜ ኮርሶች"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.recentCoursesBox = window.locales.ar.recentCoursesBox || {};window.locales.ar.recentCoursesBox = {...window.locales.ar.recentCoursesBox, ...{
    "heading": "الدورات الأخيرة"
}
};window.locales.en = window.locales.en || {};window.locales.en.recentCoursesBox = window.locales.en.recentCoursesBox || {};window.locales.en.recentCoursesBox = {...window.locales.en.recentCoursesBox, ...{
    "heading": "Recent Courses"
}
};window.locales.es = window.locales.es || {};window.locales.es.recentCoursesBox = window.locales.es.recentCoursesBox || {};window.locales.es.recentCoursesBox = {...window.locales.es.recentCoursesBox, ...{
    "heading": "Cursos Recientes"
}
};window.locales.it = window.locales.it || {};window.locales.it.recentCoursesBox = window.locales.it.recentCoursesBox || {};window.locales.it.recentCoursesBox = {...window.locales.it.recentCoursesBox, ...{
    "heading": "Corsi Recenti"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.recentCoursesBox = window.locales.zh.recentCoursesBox || {};window.locales.zh.recentCoursesBox = {...window.locales.zh.recentCoursesBox, ...{
    "heading": "最近的课程"
}
};